module.exports = __webpack_public_path__ + "img/Rectangle 42.32651799.png";